import React, { Component } from 'react'
import {Nav, Navbar} from 'react-bootstrap'
import { NavLink } from 'react-router-dom'
import catoroIMG from './assets/ctdr_nav.png'
import { connect } from 'react-redux'
import GoogleAuth from './GoogleAuth'
import { loginUser, logoutUser } from '../actions/actions'

class NavBar extends Component {
	
	loggedUserNav = () => {
		if (this.props.isLoggedIn) {
			return (
				<React.Fragment>
					<NavLink to='/cuppings/new' className="navItemsStyle"> <b>Add Cupping</b> </NavLink> &nbsp;&nbsp;
					<NavLink to='/my_cuppings' className="navItemsStyle"> My Cuppings</NavLink> &nbsp;&nbsp;
					<NavLink to='/profile' className="navItemsStyle"> My Profile</NavLink>
				</React.Fragment>
			)
		} 
	}

	renderBtn = () => {
		if (this.props.isLoggedIn) { 
			return <GoogleAuth logout={this.props.logoutBtn} isLoggedIn={true} loginUser={this.props.loginUser} logoutUser={this.props.logoutUser} isLoggedOut={false}/>
		} else if (!this.props.isLoggedIn) {
			return <GoogleAuth login={this.props.loginBtn} isLoggedIn={false} loginUser={this.props.loginUser} logoutUser={this.props.logoutUser} isLoggedOut={true}/>
		}

	}
	
	
	renderNav = () => {
		return (
			<Navbar bg="white" expand="lg" variant="light"> 
			<Navbar.Brand href="" className="name"><NavLink to='/'><img src={catoroIMG} alt="catoroimg"></img></NavLink >
				Catoro<sup>©</sup>&nbsp;&nbsp; 
				{/* logout Btn */}
				{this.props.isLoggedIn ? this.renderBtn() : null }
			</Navbar.Brand> 	
			
			<Navbar.Toggle aria-controls="basic-navbar-nav" /> 
			<Navbar.Collapse id="basic-navbar-nav"> 
				<Nav className="ml-auto">
						{this.loggedUserNav()}
					<Nav.Link >
						{/* login Btn */}
						{!this.props.isLoggedIn ? this.renderBtn() : null }
					</Nav.Link>
				</Nav>
			</Navbar.Collapse>
			</Navbar>
		)
	}
	
    render() { 
		return this.renderNav()
	}
}

const msp = state => {
	return {
	  isLoggedIn: state.users.isLoggedIn,
	  loginBtn: state.users.loginBtn,
	  logoutBtn: state.users.logoutBtn,
	}
  };
  
  export default connect(msp,{
	loginUser,
	logoutUser
  })(NavBar)